import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";
import TableCustomViewOptionsStore from "./TableCustomViewOptionsStore";

const PrintOptionDynamicColumnWidths: FunctionComponent = observer(function PrintOptionDynamicColumnWidths() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options: {
			printDynamicColumns,
		},
		setPrintDynamicColumns, 
	} = optionsStore as TableCustomViewOptionsStore;

	return (
		<>
			{isDefined(printDynamicColumns) && (
				<CheckboxOption
					label="CustomViewPrintDynamicColumns"
					onChange={setPrintDynamicColumns}
					optionValue={printDynamicColumns}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default PrintOptionDynamicColumnWidths;